const { formatMoney } = window.BAO.Utils;

export class CustomerPoints extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback();
    this.handleCustomerDetails();
  }

  setupListeners() {
    super.setupListeners();
    /*
     * Swell (Yotpo) API will use window.jQuery to dispatch events if it is available.
     * This appears to have a compatibility issue with document.addEventLister.
     */
    if (typeof window.jQuery === "undefined") {
      document.addEventListener("swell:setup", () => {
        this.handleCustomerDetails();
      });
    } else {
      window.jQuery(document).on("swell:setup", () => {
        this.handleCustomerDetails();
      });
    }
  }

  handleCustomerDetails() {
    this.swellAPI = window.swellAPI;
    this.swellConfig = window.swellConfig;

    if (!this.swellAPI || !this.swellConfig) return;

    this.customerDetails = this.swellAPI.getCustomerDetails();

    const customerPointsBalance = this.customerDetails.pointsBalance;

    this.textContent = `${customerPointsBalance}`;
  }
}

export class customerPointsWorth extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback();

    this.moneyFormat = window.theme.moneyFormat;
    this.handleCustomerDetails();
  }

  setupListeners() {
    super.setupListeners();
    /*
     * Swell (Yotpo) API will use window.jQuery to dispatch events if it is available.
     * This appears to have a compatibility issue with document.addEventLister.
     */
    if (typeof window.jQuery === "undefined") {
      document.addEventListener("swell:setup", () => {
        this.handleCustomerDetails();
      });
    } else {
      window.jQuery(document).on("swell:setup", () => {
        this.handleCustomerDetails();
      });
    }
  }

  handleCustomerDetails() {
    this.swellAPI = window.swellAPI;
    this.swellConfig = window.swellConfig;

    if (!this.swellAPI || !this.swellConfig) return;

    this.customerDetails = this.swellAPI.getCustomerDetails();

    const customerPointsWorth = this.getRewardValue();

    if (this.moneyFormat.indexOf("amount_no_decimals") === -1) {
      this.moneyFormat = this.moneyFormat.replace(
        "amount",
        "amount_no_decimals"
      );
    }

    if (customerPointsWorth == 0) {
      let parentTextEl = this.parentElement;
      let parentEl = parentTextEl.parentElement;
      if (parentEl.classList.contains("hd-Loyalty_SlidingTextWrapper")) {
        parentTextEl.remove();
        window.dispatchEvent(new Event("slidingText:updated"));
      } else {
      parentTextEl.textContent = parentTextEl.textContent
        .replace(/\bworth\b/gi, "")
        .replace(/\s+/g, " ")
        .trim();
      }
    } else {
      this.textContent = `${formatMoney(
        customerPointsWorth,
        this.moneyFormat
      )}`;
    }
  }

  getRewardValue() {
    const customerPointsBalance = this.customerDetails.pointsBalance;

    const customerPointsBalanceRounded =
      Math.floor(customerPointsBalance / 100) * 100;

    let foundReward = this.swellConfig.activeRedemptionOptions.at(-1);

    if (customerPointsBalance > foundReward.amount) {
      const foundRewardMult = customerPointsBalanceRounded / foundReward.amount;
      return foundReward.discount_amount_cents * foundRewardMult;
    } else if (customerPointsBalance <= foundReward.amount) {
      foundReward = this.swellConfig.activeRedemptionOptions.find(
        (option) => option.amount === customerPointsBalanceRounded
      );
    }

    if (!foundReward) return 0;

    return foundReward.discount_amount_cents;
  }
}

export class customerPointsNeededNextTier extends window.BAO.CustomElement() {
  connectedCallback() {
    super.connectedCallback();
  }

  setupListeners() {
    super.setupListeners();
    /*
     * Swell (Yotpo) API will use window.jQuery to dispatch events if it is available.
     * This appears to have a compatibility issue with document.addEventLister.
     */
    if (typeof window.jQuery === "undefined") {
      document.addEventListener("swell:setup", () => {
        this.handleCustomerDetails();
      });
    } else {
      window.jQuery(document).on("swell:setup", () => {
        this.handleCustomerDetails();
      });
    }
  }

  handleCustomerDetails() {
    this.swellAPI = window.swellAPI;
    this.swellConfig = window.swellConfig;

    this.customerDetails = this.swellAPI.getCustomerDetails();

    const customerPointsBalance = Number(this.customerDetails.pointsBalance);
    const customerCurrentTier = this.getCurrentTier();
    const vipTiers = this.getVipTiers();

    const currentIndex = vipTiers.findIndex(
      (tier) => tier.name === customerCurrentTier
    );

    const nextTier = vipTiers[currentIndex + 1];

    if (nextTier) {
      const nextTierPoints = Number(
        nextTier.swellrequiredAmountSpentCents / 100
      );
      const pointsNeeded = nextTierPoints - customerPointsBalance;

      this.textContent = `${pointsNeeded}`;
    } else {
      this.parentElement.remove();
    }
  }

  getCurrentTier() {
    return this.customerDetails.vipTier.name;
  }

  getVipTiers() {
    return this.swellAPI.getVipTiers();
  }
}

if (!customElements.get("customer-points")) {
  customElements.define("customer-points", CustomerPoints);
}

if (!customElements.get("customer-points-worth")) {
  customElements.define("customer-points-worth", customerPointsWorth);
}

if (!customElements.get("customer-points-needed-next-tier")) {
  customElements.define(
    "customer-points-needed-next-tier",
    customerPointsNeededNextTier
  );
}
